import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { DynamicBaseClass } from '../dynamic-base-class/dynamic-base-class.component';
import { Observable } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-dynamic-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss']
})
export class TitleComponent extends DynamicBaseClass implements OnInit, OnDestroy {

  public value$: Observable<string>;
  public class$: Observable<string>;

  constructor(
    injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.value$ = this.GetValueFromConfig();
    this.class$ = this.GetClassFromConfig("mat-h2");
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

}

